<template>
  <div id="tracker" class="">
    <h2>Shipment Status</h2>
    <button
      v-show="location_button && location_history_count"
      class="ui right floated button prim tracker-button"
      @click="openMap($event)"
    >
      <i class="fas fa-map-marked-alt"></i>Location Map
    </button>
    <ul
      class="progress-tracker progress-tracker--vertical"
      v-show="status != null"
    >
      <li
        class="progress-step"
        :class="[
          {
            'is-active':
              status.OperationOrder >= 0 && status.OperationOrder <= 4
          },
          { 'is-complete': status.OperationOrder > 4 }
        ]"
      >
        <div class="progress-marker"></div>
        <div
          class="progress-text"
          :class="{
            'progress-text-with-code': status.DelayReason != undefined
          }"
        >
          <p
            class="progress-title"
            :class="{
              'progress-title-with-code': status.DelayReason != undefined
            }"
          >
            <span
              v-show="
                (status.OperationOrder >= 0 && status.OperationOrder <= 4) ||
                  (dotStatuses != null &&
                    dotStatuses.dot_1 &&
                    status.OperationOrder > 4)
              "
            >
              <div
                v-if="status.OperationOrder >= 0 && status.OperationOrder <= 4"
              >
                {{ status.Description }} <br />
                <span
                  style="color: #707070;"
                  v-show="status.DelayReason != undefined"
                  >[{{ status.DelayReason }}]</span
                ><br v-show="status.DelayReason" />
                <span
                  style="color: #707070;font-size:12px;"
                  v-show="lastLocation"
                >
                  {{ lastLocation }} <br v-show="lastLocationDateTime" />
                  {{ lastLocationDateTime }} <br v-show="miles_to_go" /> </span
                ><span
                  style="color: #707070;font-size:12px;"
                  v-show="miles_to_go"
                >
                  {{ miles_to_go }}
                </span>
              </div>
              <div
                style="margin-top:14px;"
                v-else-if="dotStatuses != null && dotStatuses.dot_1"
              >
                <span style="color: #707070;">
                  {{ dotStatuses.dot_1 }}
                </span>
              </div>
            </span>
          </p>
        </div>
      </li>

      <li
        class="progress-step"
        :class="[
          {
            'is-active':
              status.OperationOrder >= 5 && status.OperationOrder <= 6
          },
          { 'is-complete': status.OperationOrder > 6 }
        ]"
      >
        <div class="progress-marker"></div>
        <div
          class="progress-text"
          :class="{
            'progress-text-with-code': status.DelayReason != undefined
          }"
        >
          <p
            class="progress-title"
            :class="{
              'progress-title-with-code': status.DelayReason != undefined
            }"
          >
            <span
              v-show="
                (status.OperationOrder >= 5 && status.OperationOrder <= 6) ||
                  (dotStatuses != null &&
                    dotStatuses.dot_2 &&
                    status.OperationOrder > 6)
              "
            >
              <div
                v-if="status.OperationOrder >= 5 && status.OperationOrder <= 6"
              >
                {{ status.Description }} <br />
                <span
                  style="color: #707070;"
                  v-show="status.DelayReason != undefined"
                  >[{{ status.DelayReason }}]</span
                ><br v-show="status.DelayReason" />
                <span
                  style="color: #707070;font-size:12px;"
                  v-show="lastLocation"
                >
                  {{ lastLocation }} <br v-show="lastLocationDateTime" />
                  {{ lastLocationDateTime }} <br v-show="miles_to_go" />
                  {{ miles_to_go }}</span
                >
              </div>
              <div
                style="margin-top:14px;"
                v-else-if="dotStatuses != null && dotStatuses.dot_2"
              >
                <span style="color: #707070;">
                  {{ dotStatuses.dot_2 }}
                  <br v-show="pickup_data" />
                  <span
                    v-if="pickup_data != null && pickup_data.City != null"
                    style="color: rgb(112, 112, 112); font-size: 12px;"
                  >
                    {{ pickup_data.City + ", " + pickup_data.State }}
                  </span>
                </span>
              </div>
            </span>
          </p>
        </div>
      </li>

      <li
        class="progress-step"
        :class="[
          {
            'is-active':
              status.OperationOrder >= 7 && status.OperationOrder <= 8
          },
          { 'is-complete': status.OperationOrder > 8 }
        ]"
      >
        <div class="progress-marker"></div>
        <div
          class="progress-text"
          :class="{
            'progress-text-with-code': status.DelayReason != undefined
          }"
        >
          <p
            class="progress-title"
            :class="{
              'progress-title-with-code': status.DelayReason != undefined
            }"
          >
            <span
              v-show="
                (status.OperationOrder >= 7 && status.OperationOrder <= 8) 
                ||
                (dotStatuses != null && dotStatuses.dot_3 && status.OperationOrder > 8)
              "
            >
              <div
                v-if="status.OperationOrder >= 7 && status.OperationOrder <= 8"
              >
                {{ status.Description }} <br />
                <span
                  style="color: #707070;"
                  v-show="status.DelayReason != undefined"
                  >[{{ status.DelayReason }}]</span
                ><br v-show="status.DelayReason" />
                <span style="color: #707070;font-size:12px;" v-if="oh_data && status.Description != 'ON HAND TRANSFER STATION'">
                  {{ this.oh_data.City + ", " + this.oh_data.State }}
                  <br v-show="oh_last_location_date_time" />
                  {{ oh_last_location_date_time }} <br v-show="miles_to_go" />
                  {{ miles_to_go }}</span
                >
                <span style="color: #707070;font-size:12px;" v-else>
                  {{ lastLocation }} <br v-show="lastLocationDateTime" />
                  {{ lastLocationDateTime }} <br v-show="miles_to_go" />
                  {{ miles_to_go }}</span
                >
              </div>
              <div
                style="margin-top:14px;"
                v-else-if="dotStatuses != null && dotStatuses.dot_3"
              >
                <span style="color: #707070;">
                  {{ dotStatuses.dot_3 }}
                </span>
              </div>
            </span>
          </p>
        </div>
      </li>

      <li
        class="progress-step"
        :class="[
          { 'is-active': status.OperationOrder == 9 },
          { 'is-complete': status.OperationOrder > 9 }
        ]"
      >
        <div class="progress-marker"></div>
        <div
          class="progress-text"
          :class="{
            'progress-text-with-code': status.DelayReason != undefined
          }"
        >
          <p
            class="progress-title"
            :class="{
              'progress-title-with-code': status.DelayReason != undefined
            }"
          >
            <span
              v-show="
                status.OperationOrder == 9 ||
                  (dotStatuses != null &&
                    dotStatuses.dot_4 &&
                    status.OperationOrder > 9)
              "
            >
              <div v-if="status.OperationOrder == 9">
                {{ status.Description }} <br />
                <span
                  style="color: #707070;"
                  v-show="status.DelayReason != undefined"
                  >[{{ status.DelayReason }}]</span
                ><br v-show="status.DelayReason" />
                <span
                  style="color: #707070;font-size:12px;"
                  v-if="lastLocation"
                >
                  {{ lastLocation }} <br v-show="lastLocationDateTime" />
                  {{ lastLocationDateTime }} <br v-show="miles_to_go" />
                  {{ miles_to_go }}</span
                >
                <span
                  v-else-if="
                    out_for_delivery_data != null &&
                      out_for_delivery_data.City != null
                  "
                  style="color: rgb(112, 112, 112); font-size: 12px;"
                >
                  {{
                    out_for_delivery_data.City +
                      ", " +
                      out_for_delivery_data.State
                  }}
                  <br v-show="miles_to_go" />
                  {{ miles_to_go }}
                </span>
              </div>
              <div
                style="margin-top:14px;"
                v-else-if="dotStatuses != null && dotStatuses.dot_4"
              >
                <span style="color: #707070;">
                  {{ dotStatuses.dot_4 }}
                </span>
                <br v-show="out_for_delivery_data" />
                <span
                  v-if="
                    out_for_delivery_data != null &&
                      out_for_delivery_data.City != null
                  "
                  style="color: rgb(112, 112, 112); font-size: 12px;"
                >
                  {{
                    out_for_delivery_data.City +
                      ", " +
                      out_for_delivery_data.State
                  }}
                  <br v-show="miles_to_go" />
                  {{ miles_to_go }}
                </span>
              </div>
            </span>
          </p>
        </div>
      </li>

      <li
        class="progress-step"
        :class="[
          { 'is-active': status.OperationOrder == 10 },
          { 'is-complete': status.OperationOrder >= 10 }
        ]"
      >
        <div
          class="progress-marker"
          :class="{ 'last-step': status.OperationOrder >= 10 }"
        ></div>
        <div
          class="progress-text"
          :class="{
            'progress-text-with-code': status.DelayReason != undefined
          }"
        >
          <p
            class="progress-title"
            :class="{
              'progress-title-with-code': status.DelayReason != undefined
            }"
          >
            <span v-show="status.OperationOrder >= 10">
              {{ status.Description }} <br />
              <span
                style="color: #707070;"
                v-show="status.DelayReason != undefined"
                >[{{ status.DelayReason }}]</span
              >
              <br v-show="status.DelayReason" />
              <span
                style="color: #707070;font-size:12px;"
                v-show="consignee && domestic == true"
              >
                {{ consignee.City + ", " + consignee.State }}</span
              >
            </span>
          </p>
        </div>
      </li>
    </ul>

    <div v-show="signedBy">
      <label>Signed by:</label> {{ signedBy !== null ? signedBy : "" }} <br />
      <label>Actual Delivery:</label> {{ podDate ? podDate : "" }}
      {{ podTime ? podTime : "" }}
    </div>
    <div v-show="status.OperationOrder >= 10">
      <img style="width:24px;height:24px;line-height:24px;margin-right:8px;" id="logo" src="../assets/images/clean_emissions.png" alt="ALG Logo"/><label style="line-height:24px;display:inline;">This shipment saved {{this.$parent.co2_savings}} Metric Tons of CO<sub>2</sub> <span style="cursor:pointer" v-tooltip="'This estimated CO2 savings is based on the ALG’s network utilizing newer equipment, smart dispatch programing, consolidation, and dynamic routing.'" ><i class="fas fa-info-circle"></i></span></label><br />
    </div>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script>
export default {
  props: {
    signedBy: String,
    podDate: String,
    podTime: String,
    status: Object,
    lastLocation: String,
    lastLocationDateTime: String,
    dotStatuses: Object,
    consignee: Object,
    domestic: Boolean,
    out_for_delivery_data: Object,
    pickup_data: Object,
    oh_data: Object,
    location_button: Boolean,
    location_history_count: Number,
    miles_to_go: String,
  },
  data() {
    return {
      oh_last_location: "",
      oh_last_location_date_time: ""
    };
  },
  created() {
    if(this.oh_city != null) {
      if(this.oh_data.City && this.oh_data.State) {
        this.oh_last_location = this.oh_data.City + ", " + this.oh_data.State;
      }
      if(this.oh_data.StatusDateRaw) {
        this.oh_last_location_date_time = this.oh_data.StatusDateRaw;
      }
      if(this.oh_data.StatusTimeRaw) {
        this.oh_last_location_date_time += " " + this.oh_data.StatusTimeRaw
      }
    }
  },
  mounted() {},
  methods: {
  openMap: function(event) {
      $(".ui.location_modal.modal").modal("show");
      event.preventDefault();
      Vue.$gmapDefaultResizeBus.$emit('resize');
      //Trigger resize event 20 times (every .5 seconds)
      //Refactor this
      for (var i = 0; i < 20; i++) {
          setTimeout(this.mapResize, 500 * i);
      }
    },
    mapResize(){
      Vue.$gmapDefaultResizeBus.$emit('resize');
    }
  },
  computed: {}
};
</script>

<style lang="scss">
#tracker {
  box-shadow: 0px 10px 10px #00000029;
  // margin-left: -40px;
  padding-left: 40px;
  padding-right:40px;
  padding-bottom: 20px;
  border-bottom-right-radius: 4px;

  label {
    color: $algdarkblue;
    font-weight: 600;
    font-size: 16px;
  }

  h2 {
    padding-top: 40px;
    float: left;
  }

  .tracker-button {
    margin-top: 35px;
    margin-right: 15px;
  }

  @media screen and (max-width: 1670px) {
      .tracker-button {
        margin-top: 0px;
        float:left;
        margin-bottom: 20px;
      }
    }

  .progress-tracker {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0px auto;
    padding: 0;
    padding-top: 10px;
    list-style: none;
    margin-bottom: 0px;
    // height: 550px;
    clear: both;
  }

  .progress-step {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 0%;
    flex: 1 1 0%;
    margin: 0;
    padding: 0;
    min-width: 24px;
  }

  .progress-step:last-child {
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
  }

  .progress-step:last-child .progress-marker::after {
    display: none;
  }

  .progress-link {
    display: block;
    position: relative;
  }

  .progress-marker {
    display: block;
    position: relative;
  }

  .progress-marker::before {
    content: attr(data-text);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    z-index: 20;
    width: 24px;
    height: 24px;
    padding-bottom: 2px;
    border-radius: 50%;
    -webkit-transition: background-color, border-color;
    transition: background-color, border-color;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
  }

  .progress-marker::after {
    content: "";
    display: block;
    position: absolute;
    z-index: -10;
    top: 10px;
    right: -12px;
    width: 100%;
    height: 4px;
    -webkit-transition: background-color 0.3s, background-position 0.3s;
    transition: background-color 0.3s, background-position 0.3s;
  }

  .progress-marker.last-step::before {
    background-color: $greenCheck !important;
    border: 1px solid $greenCheck !important;
    font-family: "Fontawesome";
    content: "\f00c";
    color: #fff !important;
    font-size: 12px;
    padding-top: 3px;
  }

  .progress-text {
    display: block;
    padding: 8px 8px;
    overflow: visible;
    text-overflow: ellipsis;
  }

  .progress-text-with-code {
    margin-top: -5px;
  }

  .progress-title {
    margin-top: 0;
    min-height: 100px;
    color: #b7b7b7 !important;
  }

  .progress-title-with-code {
    margin-top: -10px;
  }

  .progress-step .progress-marker {
    color: #fff;
  }

  .progress-step .progress-marker::before {
    background-color: #ffffff;
    border: 2px solid #b7b7b7;
  }

  .progress-step .progress-marker::after {
    border: 2px dashed #b7b7b7;
    background-color: transparent !important;
  }

  .progress-step .progress-text {
    color: #333;
  }

  .progress-step.is-active .progress-marker::before {
    border: 2px solid $alglightblue;
    background-color: $alglightblue;
  }

  .progress-step.is-complete .progress-marker::before,
  .progress-step.is-progress .progress-marker::before {
    border: 2px solid $alglightblue;
    background-color: $alglightblue;
  }

  .progress-step.is-complete .progress-marker::after,
  .progress-step.is-progress .progress-marker::after {
    background-color: #1a95d3;
    border: 2px solid #1a95d3;
  }

  .progress-step.is-progress-10 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(10%, #868686),
      color-stop(10%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 10%, #b6b6b6 10%);
  }

  .progress-step.is-progress-20 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(20%, #868686),
      color-stop(20%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 20%, #b6b6b6 20%);
  }

  .progress-step.is-progress-30 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(30%, #868686),
      color-stop(30%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 30%, #b6b6b6 30%);
  }

  .progress-step.is-progress-40 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(40%, #868686),
      color-stop(40%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 40%, #b6b6b6 40%);
  }

  .progress-step.is-progress-50 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(50%, #868686),
      color-stop(50%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 50%, #b6b6b6 50%);
  }

  .progress-step.is-progress-60 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(60%, #868686),
      color-stop(60%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 60%, #b6b6b6 60%);
  }

  .progress-step.is-progress-70 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(70%, #868686),
      color-stop(70%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 70%, #b6b6b6 70%);
  }

  .progress-step.is-progress-80 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(80%, #868686),
      color-stop(80%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 80%, #b6b6b6 80%);
  }

  .progress-step.is-progress-90 .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(90%, #868686),
      color-stop(90%, #b6b6b6)
    );
    background-image: linear-gradient(to right, #868686 90%, #b6b6b6 90%);
  }

  .progress-step:hover .progress-marker::before {
    background-color: #56adf5;
  }

  .progress-tracker--text .progress-step:last-child,
  .progress-tracker--center .progress-step:last-child,
  .progress-tracker--right .progress-step:last-child {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }

  .progress-tracker--center {
    text-align: center;
  }

  .progress-tracker--center .progress-marker::before,
  .progress-tracker--center .progress-text--dotted::before {
    margin-left: auto;
    margin-right: auto;
  }

  .progress-tracker--center .progress-marker::after {
    right: -50%;
  }

  .progress-tracker--right {
    text-align: right;
  }

  .progress-tracker--right .progress-marker::before,
  .progress-tracker--right .progress-text--dotted::before {
    margin-left: auto;
  }

  .progress-tracker--right .progress-marker::after {
    right: calc(-100% + 12px);
  }

  .progress-tracker--spaced .progress-marker::after {
    width: calc(100% - 40px);
    margin-left: 20px;
    margin-right: 20px;
  }

  .progress-tracker--border {
    padding: 4px;
    border: 2px solid #333;
    border-radius: 32px;
  }

  .progress-tracker--theme-red .progress-step .progress-marker {
    color: #fff;
  }

  .progress-tracker--theme-red .progress-step .progress-marker::before {
    background-color: #666;
  }

  .progress-tracker--theme-red .progress-step .progress-marker::after {
    background-color: #666;
  }

  .progress-tracker--theme-red .progress-step .progress-text {
    color: #333;
  }

  .progress-tracker--theme-red
    .progress-step.is-active
    .progress-marker::before {
    background-color: #a62d24;
  }

  .progress-tracker--theme-red
    .progress-step.is-complete
    .progress-marker::before {
    background-color: #d93b30;
  }

  .progress-tracker--theme-red
    .progress-step.is-complete
    .progress-marker::after {
    background-color: #333;
  }

  .progress-tracker--theme-red .progress-step:hover .progress-marker::before {
    background-color: #df7b74;
  }

  .progress-text--dotted::before {
    content: "";
    display: block;
    width: 12px;
    height: 12px;
    margin: 6px -2px;
    background-size: 12px 18px;
    background-image: repeating-radial-gradient(
      circle at center 6px,
      #b6b6b6,
      #b6b6b6 5px,
      rgba(182, 182, 182, 0.5) 5.5px,
      rgba(182, 182, 182, 0.01) 6px,
      transparent 100%
    );
  }

  .progress-text--dotted-1::before {
    height: 12px;
  }

  .progress-text--dotted-2::before {
    height: 30px;
  }

  .progress-text--dotted-3::before {
    height: 48px;
  }

  .progress-text--dotted-4::before {
    height: 66px;
  }

  .progress-text--dotted-5::before {
    height: 84px;
  }

  .progress-text--dotted-6::before {
    height: 102px;
  }

  .progress-text--dotted-7::before {
    height: 120px;
  }

  .progress-text--dotted-8::before {
    height: 138px;
  }

  .progress-text--dotted-9::before {
    height: 156px;
  }

  .progress-text--dotted-10::before {
    height: 174px;
  }

  .progress-text--dotted-11::before {
    height: 192px;
  }

  .progress-text--dotted-12::before {
    height: 210px;
  }

  .progress-tracker--text-top .progress-text {
    height: 100%;
  }

  .progress-tracker--text-top .progress-marker {
    top: -24px;
  }

  .progress-tracker--text-inline {
    overflow: hidden;
  }

  .progress-tracker--text-inline .progress-step,
  .progress-tracker--text-inline .progress-marker {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .progress-tracker--text-inline .progress-marker {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }

  .progress-tracker--text-inline .progress-marker::after {
    top: auto;
  }

  .progress-tracker--text-inline .progress-text {
    position: relative;
    z-index: 30;
    max-width: 70%;
    white-space: nowrap;
    padding-top: 0;
    padding-bottom: 0;
    background-color: #fff;
  }

  .progress-tracker--text-inline .progress-marker .progress-text {
    display: inline-block;
  }

  .progress-tracker--text-inline .progress-title {
    margin: 0;
  }

  .progress-tracker--square .progress-marker::before {
    border-radius: 0;
  }

  .progress-tracker--square .progress-marker::after {
    top: auto;
    bottom: 0;
  }

  @media (max-width: 575px) {
    .progress-tracker-wrapper {
      overflow-x: auto;
      -ms-scroll-snap-type: x proximity;
      scroll-snap-type: x proximity;
    }
    .progress-tracker-wrapper .progress-step {
      min-width: 50%;
      scroll-snap-align: start;
    }
    .tracker-button{
      width:100%;
    }
  }


  .progress-tracker--vertical {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .progress-tracker--vertical .progress-step {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }

  .progress-tracker--vertical.progress-tracker--right .progress-step {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
  }

  .progress-tracker--vertical .progress-marker::after {
    right: auto;
    top: 12px;
    left: 10px;
    width: 4px;
    height: 100%;
  }

  .progress-tracker--vertical .progress-text {
    padding: 0 12px 4% 12px;
  }

  @-webkit-keyframes scale-up {
    from {
      opacity: 1;
      -webkit-transform: translate(-50%, -50%) scale(0);
      transform: translate(-50%, -50%) scale(0);
    }
    to {
      opacity: 0;
      -webkit-transform: translate(-50%, -50%) scale(1);
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes scale-up {
    from {
      opacity: 1;
      -webkit-transform: translate(-50%, -50%) scale(0);
      transform: translate(-50%, -50%) scale(0);
    }
    to {
      opacity: 0;
      -webkit-transform: translate(-50%, -50%) scale(1);
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .anim-ripple .progress-link::before,
  .anim-ripple-large .progress-link::before,
  .anim-ripple-splash .progress-link::before {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 30;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    -webkit-transform: translate(-50%, -50%) scale(0);
    transform: translate(-50%, -50%) scale(0);
    visibility: hidden;
  }

  .anim-ripple .progress-link:not(:active)::before,
  .anim-ripple-large .progress-link:not(:active)::before,
  .anim-ripple-splash .progress-link:not(:active)::before {
    -webkit-animation: scale-up 0.3s ease-out;
    animation: scale-up 0.3s ease-out;
  }

  .anim-ripple .progress-link:focus::before,
  .anim-ripple-large .progress-link:focus::before,
  .anim-ripple-splash .progress-link:focus::before {
    visibility: visible;
  }

  .anim-ripple.progress-tracker--center .progress-link::before,
  .anim-ripple.progress-tracker--center .progress-link::after,
  .progress-tracker--center .anim-ripple .progress-link::before,
  .progress-tracker--center .anim-ripple .progress-link::after,
  .anim-ripple-large.progress-tracker--center .progress-link::before,
  .anim-ripple-large.progress-tracker--center .progress-link::after,
  .progress-tracker--center .anim-ripple-large .progress-link::before,
  .progress-tracker--center .anim-ripple-large .progress-link::after,
  .anim-ripple-splash.progress-tracker--center .progress-link::before,
  .anim-ripple-splash.progress-tracker--center .progress-link::after,
  .progress-tracker--center .anim-ripple-splash .progress-link::before,
  .progress-tracker--center .anim-ripple-splash .progress-link::after,
  .anim-ripple-double.progress-tracker--center .progress-link::before,
  .anim-ripple-double.progress-tracker--center .progress-link::after,
  .progress-tracker--center .anim-ripple-double .progress-link::before,
  .progress-tracker--center .anim-ripple-double .progress-link::after {
    left: 50%;
  }

  .anim-ripple.progress-tracker--right .progress-link::before,
  .anim-ripple.progress-tracker--right .progress-link::after,
  .progress-tracker--right .anim-ripple .progress-link::before,
  .progress-tracker--right .anim-ripple .progress-link::after,
  .anim-ripple-large.progress-tracker--right .progress-link::before,
  .anim-ripple-large.progress-tracker--right .progress-link::after,
  .progress-tracker--right .anim-ripple-large .progress-link::before,
  .progress-tracker--right .anim-ripple-large .progress-link::after,
  .anim-ripple-splash.progress-tracker--right .progress-link::before,
  .anim-ripple-splash.progress-tracker--right .progress-link::after,
  .progress-tracker--right .anim-ripple-splash .progress-link::before,
  .progress-tracker--right .anim-ripple-splash .progress-link::after,
  .anim-ripple-double.progress-tracker--right .progress-link::before,
  .anim-ripple-double.progress-tracker--right .progress-link::after,
  .progress-tracker--right .anim-ripple-double .progress-link::before,
  .progress-tracker--right .anim-ripple-double .progress-link::after {
    left: calc(100% - 12px);
  }

  .anim-ripple-splash .progress-link::before {
    width: 48px;
    height: 48px;
    -webkit-box-shadow: 0 0 6px 6px rgba(0, 0, 0, 0.35);
    box-shadow: 0 0 6px 6px rgba(0, 0, 0, 0.35);
  }

  .anim-ripple-double .progress-link::before,
  .anim-ripple-double .progress-link::after {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 30;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    -webkit-transform: translate(-50%, -50%) scale(0);
    transform: translate(-50%, -50%) scale(0);
    visibility: hidden;
    background: none;
    border: 3px solid rgba(0, 0, 0, 0.3);
  }

  .anim-ripple-double .progress-link:not(:active)::before,
  .anim-ripple-double .progress-link:not(:active)::after {
    -webkit-animation: scale-up 0.3s ease-out 0s;
    animation: scale-up 0.3s ease-out 0s;
  }

  .anim-ripple-double .progress-link:not(:active)::after {
    -webkit-animation-delay: 0.15s;
    animation-delay: 0.15s;
  }

  .anim-ripple-double .progress-link:focus::before,
  .anim-ripple-double .progress-link:focus::after {
    visibility: visible;
  }

  .anim--large .progress-link::before,
  .anim--large .progress-link::after {
    width: 48px;
    height: 48px;
  }

  .anim--path .progress-marker::after {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(50%, #b6b6b6),
      color-stop(50%, #868686)
    );
    background-image: linear-gradient(to right, #b6b6b6 50%, #868686 50%);
    background-size: 200% 100%;
    background-position: 0% 100%;
    -webkit-transition: background-position 0.3s ease-out;
    transition: background-position 0.3s ease-out;
  }

  .progress-step.is-complete .anim--path .progress-marker::after {
    background-position: -100% 100%;
  }

  .anim--path .progress-step.is-complete .progress-marker::after {
    background-position: -100% 100%;
  }

  [dir="rtl"] .progress-marker::after {
    right: auto;
    left: -12px;
  }

  [dir="rtl"] .progress-tracker--center .progress-marker::after {
    left: -50%;
  }

  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
  /* Document
    ========================================================================== */
  /**
  * 1. Correct the line height in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  */
  html {
    line-height: 1.15;
    /* 1 */
    -webkit-text-size-adjust: 100%;
    /* 2 */
  }

  /* Sections
    ========================================================================== */
  /**
  * Remove the margin in all browsers.
  */
  body {
    margin: 0;
  }

  /**
  * Render the `main` element consistently in IE.
  */
  main {
    display: block;
  }

  /**
  * Correct the font size and margin on `h1` elements within `section` and
  * `article` contexts in Chrome, Firefox, and Safari.
  */
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
    ========================================================================== */
  /**
  * 1. Add the correct box sizing in Firefox.
  * 2. Show the overflow in Edge and IE.
  */
  hr {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    /* 1 */
    height: 0;
    /* 1 */
    overflow: visible;
    /* 2 */
  }

  /**
  * 1. Correct the inheritance and scaling of font size in all browsers.
  * 2. Correct the odd `em` font sizing in all browsers.
  */
  pre {
    font-family: monospace, monospace;
    /* 1 */
    font-size: 1em;
    /* 2 */
  }

  /* Text-level semantics
    ========================================================================== */
  /**
  * Remove the gray background on active links in IE 10.
  */
  a {
    background-color: transparent;
  }

  /**
  * 1. Remove the bottom border in Chrome 57-
  * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
  */
  abbr[title] {
    border-bottom: none;
    /* 1 */
    text-decoration: underline;
    /* 2 */
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    /* 2 */
  }

  /**
  * Add the correct font weight in Chrome, Edge, and Safari.
  */
  b,
  strong {
    font-weight: bolder;
  }

  /**
  * 1. Correct the inheritance and scaling of font size in all browsers.
  * 2. Correct the odd `em` font sizing in all browsers.
  */
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    /* 1 */
    font-size: 1em;
    /* 2 */
  }

  /**
  * Add the correct font size in all browsers.
  */
  small {
    font-size: 80%;
  }

  /**
  * Prevent `sub` and `sup` elements from affecting the line height in
  * all browsers.
  */
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
    ========================================================================== */
  /**
  * Remove the border on images inside links in IE 10.
  */
  img {
    border-style: none;
  }

  /* Forms
    ========================================================================== */
  /**
  * 1. Change the font styles in all browsers.
  * 2. Remove the margin in Firefox and Safari.
  */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    /* 1 */
    font-size: 100%;
    /* 1 */
    line-height: 1.15;
    /* 1 */
    margin: 0;
    /* 2 */
  }

  /**
  * Show the overflow in IE.
  * 1. Show the overflow in Edge.
  */
  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
  * Remove the inheritance of text transform in Edge, Firefox, and IE.
  * 1. Remove the inheritance of text transform in Firefox.
  */
  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
  * Correct the inability to style clickable types in iOS and Safari.
  */
  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  /**
  * Remove the inner border and padding in Firefox.
  */
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
  * Restore the focus styles unset by the previous rule.
  */
  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
  * Correct the padding in Firefox.
  */
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
  * 1. Correct the text wrapping in Edge and IE.
  * 2. Correct the color inheritance from `fieldset` elements in IE.
  * 3. Remove the padding so developers are not caught out when they zero out
  *    `fieldset` elements in all browsers.
  */
  legend {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* 1 */
    color: inherit;
    /* 2 */
    display: table;
    /* 1 */
    max-width: 100%;
    /* 1 */
    padding: 0;
    /* 3 */
    white-space: normal;
    /* 1 */
  }

  /**
  * Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */
  progress {
    vertical-align: baseline;
  }

  /**
  * Remove the default vertical scrollbar in IE 10+.
  */
  textarea {
    overflow: auto;
  }

  /**
  * 1. Add the correct box sizing in IE 10.
  * 2. Remove the padding in IE 10.
  */
  [type="checkbox"],
  [type="radio"] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* 1 */
    padding: 0;
    /* 2 */
  }

  /**
  * Correct the cursor style of increment and decrement buttons in Chrome.
  */
  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  */
  [type="search"] {
    -webkit-appearance: textfield;
    /* 1 */
    outline-offset: -2px;
    /* 2 */
  }

  /**
  * Remove the inner padding in Chrome and Safari on macOS.
  */
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
  * 1. Correct the inability to style clickable types in iOS and Safari.
  * 2. Change font properties to `inherit` in Safari.
  */
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    /* 1 */
    font: inherit;
    /* 2 */
  }

  /* Interactive
    ========================================================================== */
  /*
  * Add the correct display in Edge, IE 10+, and Firefox.
  */
  details {
    display: block;
  }

  /*
  * Add the correct display in all browsers.
  */
  summary {
    display: list-item;
  }

  /* Misc
    ========================================================================== */
  /**
  * Add the correct display in IE 10+.
  */
  template {
    display: none;
  }

  /**
  * Add the correct display in IE 10.
  */
  [hidden] {
    display: none;
  }

  *,
  *:before,
  *:after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  body {
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    background-color: #fff;
  }

  a {
    color: #1976d2;
    text-decoration: none;
    -webkit-transition: color 0.3s;
    transition: color 0.3s;
  }

  a:hover,
  a:focus {
    color: #2196f3;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.2;
    font-weight: 300;
  }

  h1 small,
  h2 small,
  h3 small,
  h4 small,
  h5 small,
  h6 small {
    font-size: 60%;
  }

  h1,
  h2 {
    margin: 0 0 1.5rem 0;
  }

  h3 {
    margin: 0 0 1rem 0;
  }

  h4,
  h5,
  h6 {
    margin: 0 0 0.5rem 0;
    font-weight: 400;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    margin: 0 0 1rem 0;
  }

  strong,
  th {
    font-weight: 800;
  }

  pre,
  code {
    font-family: "Cutive Mono", monospace;
    background-color: #f3f3f3;
  }

  pre {
    display: block;
    padding: 0.75rem 1rem;
    margin: 0 0 2rem 0;
    overflow: auto;
    font-size: 1rem;
    word-break: break-all;
    word-wrap: break-word;
    border: 1px solid #bbb;
    border-radius: 4px;
  }

  .table-wrapper {
    display: block;
    width: 100%;
    overflow-x: auto;
  }

  .table {
    width: 100%;
    margin: 0 0 1.5rem 0;
    border-collapse: collapse;
  }

  .table th,
  .table td {
    padding: 0.25rem 0.5rem;
    text-align: left;
    vertical-align: top;
    border: 1px solid #ddd;
  }

  .img-fluid {
    max-width: 100%;
    height: auto;
  }

  .fullwidth .container {
    width: 100%;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .fullwidth--sm .container {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .container {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .subsection {
    margin: 0 0 2rem 0;
  }

  .separator {
    border-bottom: 1px solid #ddd;
  }

  .header {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    padding: 0.5rem 0;
    color: #fff;
    background-color: #1976d2;
    -webkit-box-shadow: 0 0 6px 6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 6px 6px rgba(0, 0, 0, 0.1);
  }

  @media (min-width: 768px) {
    .header {
      padding: 1rem 0;
    }
  }

  .header .container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  @media (max-width: 575px) {
    .header .container {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-flow: column;
      flex-flow: column;
    }
  }

  @media (min-width: 576px) {
    .header .container {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    
  }

  .logo-text {
    margin: 0;
  }

  @media (max-width: 767px) {
    .logo-text {
      font-size: 1.75rem;
    }
  }

  .header-links .btn-demo {
    margin: 0.5rem 0;
  }

  .header-links .btn-demo:last-child {
    margin-left: 0.5rem;
  }

  @media (min-width: 576px) {
    .header-links {
      margin-left: auto;
    }
  }

  .footer {
    text-align: center;
  }

  .btn-demo {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid #bbb;
    padding: 4px 12px 6px 12px;
    font-size: 18px;
    background-color: #fff;
    border-radius: 4px;
    -webkit-transition: background-color 0.3s, color 0.3s;
    transition: background-color 0.3s, color 0.3s;
  }

  .btn-demo:hover,
  .btn-demo:focus,
  .btn-demo:active {
    background-color: #f3f3f3;
  }

  .btn-demo--white {
    color: #fff;
    border-color: #fff;
    background-color: transparent;
  }

  .m-0 {
    margin: 0;
  }
}

</style>
